// extracted by mini-css-extract-plugin
export default {"accordionsWrapper":"accordionsWrapper---rQzZt"};